module.exports = __webpack_public_path__ + "static/img/logo_20230718.6668b6f8.svg";